import { Stack, Typography } from '@mui/material';
import { IFamilyMembers } from 'API/personalDetails';
import { FamilyCard } from '../FamilyCard';

interface Props {
  title: string;
  partner: IFamilyMembers;
}

export const PartnerInfo = ({ title, partner }: Props) => {
  return (
    <Stack gap={'16px'}>
      <Typography variant={'body6'} component='h3'>
        {title}
      </Typography>
      <Stack width={'250px'}>
        <FamilyCard familyMember={partner} />
      </Stack>
    </Stack>
  );
};
